import React, {Component} from "react";
import AsyncSelect from "react-select/async";
import Axios from "axios";
import {estados} from "../util/estados";
import anos_lancamento from "../util/anos_lancamento";
import estagios from "../util/estagios";
import IntlCurrencyInput from "react-intl-currency-input";
import DatePicker from "react-datepicker";
import {Dropdown} from 'primereact/dropdown';
import {MultiSelect} from 'primereact/multiselect';
import {reactSelectIcons} from "../util/reactSelectPrimeIcons";
import {asyncSelectCustomStyles} from "../util/styles";
import {InputSwitch} from "primereact/inputswitch";


const currencyConfig = {
    locale: "pt-BR",
    formats: {
        number: {
            BRL: {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
        },
    },
};

class FormFilters extends Component {
    constructor(props) {
        super(props);
        this.state = {
            estados: estados,
            cidades: [],
            address: "",
            incorporadoras: [],
            types: [],
            buscaIncorporadorasDefaultOptions: [],
            buscaCidadesDefaultOptions: [],
            inputBairroValue: "",
            anos_lancamento_options: anos_lancamento,
        };
    }

    tiposEmpreendimentos = window.authenticatedUserCanViewHotelFilter
        ? ['Vertical', 'Horizontal', 'Comercial', 'Hotel']
        : ['Vertical', 'Horizontal', 'Comercial'];
    dormitorios = [1, 2, 3, 4, 'Studio'];

    regioes = [
        {
            value: "Sul",
            label: "Sul",
        },
        {
            value: "Sudeste",
            label: "Sudeste",
        },
        {
            value: "Nordeste",
            label: "Nordeste",
        },
        {
            value: "Centro-Oeste",
            label: "Centro-Oeste",
        },
        {
            value: "Norte",
            label: "Norte",
        },
    ];


    loadTypes = async () => {
        try {
            let response = await axios.get(route("polos-geradores-tipos"));

            if (response.status === 200) {
                let types = response.data.types;

                let options = [];

                types.forEach((type) => {
                    options.push({value: type, label: type});
                });

                this.setState({types: options});
            }
        } catch (e) {
            console.log(e);
        }
    };

    componentDidMount = async () => {
        await this.props.getProjects();
        await this.loadTypes();
    };

    searchIncorporadora = async (inputQuery) => {
        if (inputQuery.length >= 2) {
            const response = await Axios.get("/incorporadoras-json?incorporadora=" + inputQuery);
            await this.setState({buscaIncorporadorasDefaultOptions: response.data})
            return response.data;
        }
    };

    searchCidade = async (inputQuery) => {
        let state =
            this.props.estadosSelecionados != null && this.props.estadosSelecionados.length > 0
                ? this.props.estadosSelecionados
                : estados.map((index) => {
                    return index.value
                });


        if (inputQuery.length >= 2) {
            const response = await Axios.get(
                "/cidades/json-options-by-state/" + state + "/" + inputQuery
            );

            await this.setState({buscaCidadesDefaultOptions: response.data})

            return response.data;
        }
    };

    /**
     * Label do campo Cidade (opções e itens selecionados): só o nome da cidade. A UF
     * aparece no label quando a cidade é resolvida por geocodificação (busca por
     * endereço, formas importadas) ou vem salva num projeto antigo — o valor
     * ("UF-Cidade") continua intacto, muda apenas o que é exibido.
     */
    cidadeOptionLabel = (option) => String(option?.label ?? '').replace(/\s*-\s*[A-Za-z]{2}$/, '');

    /**
     * Label do empreendimento no campo: a opção do autocomplete vem como
     * "Nome - Cidade/UF". No item selecionado fica só o nome; no menu a cidade
     * permanece, porque sem cidade escolhida a busca é nacional e distingue homônimos.
     */
    empreendimentoOptionLabel = (option, { context }) => {
        const label = String(option?.label ?? '');
        if (context !== 'value') {
            return label;
        }

        // Corta pelo ÚLTIMO " - ": o nome do empreendimento pode ter hifens.
        const separador = label.lastIndexOf(' - ');
        const cidadeUf = separador > 0 ? label.slice(separador + 3) : '';

        return /^[^/]+\/[A-Za-z]{2}$/.test(cidadeUf) ? label.slice(0, separador) : label;
    };

    handleValorMaximoChange = (event, value, maskedValue) => {
        event.preventDefault();

        this.props.handleValorMaximoChanged(value);
    };

    handleValorMinimoChange = (event, value, maskedValue) => {
        event.preventDefault();

        this.props.handleValorMinimoChanged(value);
    };

    handleValorMetroMaximoChange = (event, value, maskedValue) => {
        event.preventDefault();

        this.props.handleValorMetroMaximoChanged(value);
    };

    handleValorMetroMinimoChange = (event, value, maskedValue) => {
        event.preventDefault();

        this.props.handleValorMetroMinimoChanged(value);
    };

    handleValorParcelaMaximaChange = (event, value, maskedValue) => {
        event.preventDefault();

        this.props.handleValorParcelaMaximaChanged(value);
    };

    handleValorParcelaMinimaChange = (event, value, maskedValue) => {
        event.preventDefault();

        this.props.handleValorParcelaMinimaChanged(value);
    };

    render() {
        let statusStates =
            this.props.estadosSelecionados != null &&
            this.props.estadosSelecionados.length === this.state.estados.length;

        return (
            <div
                id="form-filters-wrapper"
                style={{overflowX: "hidden", paddingLeft: '6px', paddingRight: '6px' }}
            >
                <div className="card filtro-mapa">
                    <div className="card-body" style={{marginTop: "10px"}}>
                        <div className="form-group">
                            <div className="form-group">
                                <label>Carregar projeto</label>
                                <Dropdown
                                    value={this.props.projeto}
                                    options={this.props.projetos}
                                    onChange={this.props.handleProjetoChanged}
                                    style={{width: "100%", borderRadius: '0px'}}
                                    components={reactSelectIcons}
                                    placeholder="Selecione"
                                    display={"chip"}
                                    filter
                                    filterBy="label"
                                    filterPlaceholder="Buscar projeto"
                                    resetFilterOnHide
                                />
                            </div>

                            <label>Tipo de empreendimento</label>
                            <br/>
                            {this.tiposEmpreendimentos.map((tipo) => {
                                return (
                                    <div className="form-check checkbox-inline pr-1">
                                        <div className="d-flex align-items-center">
                                            <InputSwitch
                                                id={"check_" + tipo.toLowerCase()}
                                                checked={this.props.tipo_empreendimento.includes(tipo)}
                                                onChange={(e) => this.props.handleTipoEmpreendimentoChanged(tipo)}
                                            />
                                            <label htmlFor={"check_" + tipo.toLowerCase()} className="pl-1 mb-0 ms-2">
                                                {tipo}
                                            </label>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        <div className="form-group">
                            <label>Nome do empreendimento</label>
                            <AsyncSelect
                                isMulti
                                onMenuClose={this.props.clearDefaultEmpreendimentos}
                                closeMenuOnSelect={false}
                                defaultOptions={this.props.buscaEmpreendimentossDefaultOptions}
                                value={this.props.nome_empreendimento}
                                loadOptions={this.props.searchEmpreendimentos}
                                formatOptionLabel={this.empreendimentoOptionLabel}
                                onChange={this.props.handleNomeEmpreendimentoChanged}
                                styles={asyncSelectCustomStyles}
                                placeholder="Digite"
                                components={reactSelectIcons}
                                noOptionsMessage={() => "Digite para buscar..."}
                                loadingMessage={() => 'Carregando...'}

                            />
                        </div>
                        <div className="form-group">
                            <label>Padrão</label> <br/>
                            <MultiSelect
                                resetFilterOnHide
                                value={this.props.padrao}
                                options={this.props.getPadroes()}
                                onChange={this.props.handlePadraoChanged}
                                style={{width: "100%", borderRadius: '0px'}}
                                placeholder="Selecione"
                                display={"chip"}
                                filter
                                showClear={true}
                                maxSelectedLabels={3}
                                selectedItemsLabel={"{0} items selecionados"}
                                emptyFilterMessage={"Nenhum resultado encontrado"}
                            />
                        </div>
                        <div className="form-group">
                            <label>Status</label><br/>
                            <MultiSelect
                                resetFilterOnHide
                                value={this.props.status}
                                options={this.props.statusOptions || [
                                    {value: "Comercialização", label: "Comercialização",},
                                    {value: "Esgotado", label: "Esgotado"},
                                    {value: "Futuro", label: "Futuro"},
                                    {value: "Suspenso", label: "Suspenso"},
                                ]}
                                onChange={this.props.handleStatusChanged}
                                style={{width: "100%", borderRadius: '0px'}}

                                placeholder="Selecione"
                                display={"chip"}
                                filter
                                showClear={true}
                                maxSelectedLabels={3}
                                selectedItemsLabel={"{0} items selecionados"}
                                emptyFilterMessage={"Nenhum resultado encontrado"}

                            />
                        </div>
                        <div className="form-group">
                            <label>Retrofit</label><br/>
                            <MultiSelect
                                resetFilterOnHide
                                value={this.props.retrofit}
                                options={[
                                    {value: 1, label: "Sim",},
                                    {value: 0, label: "Não"},
                                ]}
                                onChange={this.props.handleRetrofitChanged}
                                style={{width: "100%", borderRadius: '0px'}}

                                placeholder="Selecione"
                                display={"chip"}
                                showClear={true}
                                maxSelectedLabels={3}
                                selectedItemsLabel={"{0} items selecionados"}
                                emptyFilterMessage={"Nenhum resultado encontrado"}

                            />
                        </div>
                        <div className="form-group">
                            <label>Incorporadora</label>
                            <AsyncSelect
                                styles={asyncSelectCustomStyles}
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                    colors: {
                                        ...theme.colors,
                                        primary25: "#F2F2F2",
                                        primary: "#5B7537",
                                    },
                                })}
                                isMulti
                                onMenuClose={() => this.setState({buscaIncorporadorasDefaultOptions: []})}
                                closeMenuOnSelect={false}
                                defaultOptions={this.state.buscaIncorporadorasDefaultOptions}
                                value={this.props.incorporators}
                                loadOptions={this.props.searchIncorporadora || this.searchIncorporadora}
                                onChange={this.props.handleIncorporadoraChanged}
                                placeholder="Digite"
                                components={reactSelectIcons}
                                noOptionsMessage={() => "Digite para buscar..."}
                                loadingMessage={() => 'Carregando...'}

                            />
                        </div>
                        <div className="form-group">
                            <label>Região</label>
                            <br/>
                            <MultiSelect
                                resetFilterOnHide
                                value={this.props.regiao}
                                options={this.regioes}
                                onChange={this.props.handleRegiaoChanged}
                                style={{width: "100%", borderRadius: '0px'}}

                                placeholder="Selecione"
                                display={"chip"}
                                showClear={true}
                                maxSelectedLabels={3}
                                selectedItemsLabel={"{0} items selecionados"}
                                emptyFilterMessage={"Nenhum resultado encontrado"}

                            />
                        </div>
                        <div className="form-group">
                            <label style={{marginRight: "10px"}}>
                                Estado
                            </label>

                            <MultiSelect
                                resetFilterOnHide
                                options={estados}
                                value={this.props.estadosSelecionados}
                                style={{width: "100%", borderRadius: '0px'}}

                                placeholder="Selecione"
                                display={"chip"}
                                showClear={true}
                                maxSelectedLabels={3}
                                selectedItemsLabel={"{0} items selecionados"}
                                onChange={this.props.handleEstadosChanged}
                                filter
                                emptyFilterMessage={"Nenhum resultado encontrado"}

                            />
                        </div>
                        <div className="form-group">
                            <label>Cidade</label>
                            <AsyncSelect
                                styles={asyncSelectCustomStyles}
                                placeholder="Selecione"
                                isMulti
                                onMenuClose={() => this.setState({buscaCidadesDefaultOptions: []})}
                                closeMenuOnSelect={false}
                                defaultOptions={this.state.buscaCidadesDefaultOptions}
                                value={this.props.cidade}
                                loadOptions={this.searchCidade}
                                getOptionLabel={this.cidadeOptionLabel}
                                onChange={this.props.handleCidadeChanged}
                                components={reactSelectIcons}
                                loadingMessage={() => 'Carregando...'}
                                noOptionsMessage={() => "Digite para buscar..."}


                            />
                        </div>
                        <div className="form-group">
                            <label>Cluster</label>

                            <Dropdown
                                filter={true}
                                style={{width: "100%",}}
                                showClear={this.props.cluster != '' ? true : false}
                                value={this.props.cluster}
                                options={this.props.opcoes_clustes}
                                onChange={this.props.handleClusterChanged}
                                placeholder="Selecione"
                                emptyFilterMessage={"Nenhum resultado encontrado"}

                            />
                        </div>

                        <div className="form-group">
                            <label>Bairros</label>
                            <MultiSelect
                                resetFilterOnHide
                                options={this.props.bairrosOptions}
                                value={this.props.bairros}
                                style={{width: "100%", borderRadius: '0px'}}

                                placeholder="Selecione"
                                display={"chip"}
                                showClear={true}
                                maxSelectedLabels={3}
                                selectedItemsLabel={"{0} items selecionados"}
                                onChange={this.props.handleBairrosChanged}
                                filter
                                emptyFilterMessage={"Nenhum resultado encontrado"}

                            />
                        </div>

                        <div className="form-group row">
                            <div className="col-md-6 col-sm-6 col-lg-6">
                                <label>Área mínima</label>
                                <input
                                    type="number"
                                    name="area_minima"
                                    value={this.props.area_minima}
                                    onChange={
                                        this.props.handleAreaMinimaChanged
                                    }
                                    style={{padding: "3px"}}
                                    className="form-control"
                                />
                            </div>
                            <div className="col-md-6 col-sm-6 col-lg-6">
                                <label>Área máxima</label>
                                <input
                                    type="number"
                                    name="area_maxima"
                                    value={this.props.area_maxima}
                                    onChange={
                                        this.props.handleAreaMaximaChanged
                                    }
                                    style={{padding: "3px"}}
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <div className="col-md-6 col-sm-6 col-lg-6">
                                <label>% Vendida mínima</label>
                                <input
                                    type="number"
                                    name="porcentagem_vendida_minima"
                                    value={
                                        this.props.porcentagem_vendida_minima
                                    }
                                    onChange={
                                        this.props
                                            .handlePorcentagemVendidaMinimaChanged
                                    }
                                    style={{padding: "3px"}}
                                    className="form-control"
                                />
                            </div>
                            <div className="col-md-6 col-sm-6 col-lg-6">
                                <label>% Vendida máxima</label>
                                <input
                                    type="number"
                                    name="area_maxima"
                                    value={
                                        this.props.porcentagem_vendida_maxima
                                    }
                                    onChange={
                                        this.props
                                            .handlePorcentagemVendidaMaximaChanged
                                    }
                                    style={{padding: "3px"}}
                                    className="form-control"
                                />
                            </div>
                        </div>

                        <div className="form-group row">
                            <div className="col-md-6 col-sm-6 col-lg-6">
                                <label>Preço mínimo</label>

                                <IntlCurrencyInput
                                    currency="BRL"
                                    config={currencyConfig}
                                    value={this.props.valor_maior_que}
                                    onChange={this.handleValorMinimoChange}
                                    style={{padding: "3px"}}
                                    className="valor form-control"
                                />
                            </div>
                            <div className="col-md-6 col-sm-6 col-lg-6">
                                <label>Preço máximo</label>
                                <IntlCurrencyInput
                                    currency="BRL"
                                    config={currencyConfig}
                                    onChange={this.handleValorMaximoChange}
                                    style={{padding: "3px"}}
                                    className="valor form-control"
                                    value={this.props.valor_menor_que}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <div className="col-md-6 col-sm-6 col-lg-6">
                                <label>
                                    Preço R$/m<sup>2</sup> mínimo
                                </label>
                                <IntlCurrencyInput
                                    currency="BRL"
                                    config={currencyConfig}
                                    onChange={this.handleValorMetroMinimoChange}
                                    style={{padding: "3px"}}
                                    value={this.props.valor_metro_maior_que}
                                    className="valor form-control"
                                />
                            </div>
                            <div className="col-md-6 col-sm-6 col-lg-6">
                                <label>
                                    Preço R$/m<sup>2</sup> máximo
                                </label>
                                <IntlCurrencyInput
                                    currency="BRL"
                                    config={currencyConfig}
                                    onChange={this.handleValorMetroMaximoChange}
                                    style={{padding: "3px"}}
                                    value={this.props.valor_metro_menor_que}
                                    className="valor form-control"
                                />
                            </div>
                        </div>
                        <div className="form-group margin-bottom-0">
                            <label>Quartos</label>
                            <br/>

                            {this.dormitorios.map((tipo) => {
                                return (
                                    <div className="form-check checkbox-inline pr-1">
                                        <div className="d-flex align-items-center">
                                            <InputSwitch
                                                id={"check_quarto_" + tipo}
                                                checked={this.props.quartos.includes(tipo)}
                                                onChange={(e) => this.props.handleQuartosChanged(tipo)}
                                            />
                                            <label htmlFor={"check_quarto_" + tipo} className="pl-1 mb-0 ms-2">
                                                {tipo}
                                            </label>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        {this.props.showResaleOrLocationMarkers && (
                            <div className="form-group">
                                <label>Vagas</label>
                                <br/>
                                <div className="form-check checkbox-inline">
                                    <input
                                        className="form-check-input"
                                        name="check_vagas1"
                                        id="check_vagas1"
                                        checked={this.props.vagas.includes(1)}
                                        onChange={this.props.handleVagasChanged}
                                        type="checkbox"
                                        value="1"
                                    />
                                    <span className="slider"></span>
                                    <label
                                        htmlFor="check_vagas1"
                                        className="form-check-label margin-check"
                                    >
                                        1
                                    </label>
                                </div>
                                <div className="form-check checkbox-inline">
                                    <input
                                        className="form-check-input"
                                        name="check_vagas2"
                                        id="check_vagas2"
                                        onChange={this.props.handleVagasChanged}
                                        checked={this.props.vagas.includes(2)}
                                        type="checkbox"
                                        value="2"
                                    />
                                    <span className="slider"></span>
                                    <label
                                        htmlFor="check_vagas2"
                                        className="form-check-label margin-check"
                                    >
                                        2
                                    </label>
                                </div>
                                <div className="form-check checkbox-inline">
                                    <input
                                        className="form-check-input"
                                        name="check_vagas3"
                                        id="check_vagas3"
                                        checked={this.props.vagas.includes(3)}
                                        onChange={this.props.handleVagasChanged}
                                        type="checkbox"
                                        value="3"
                                    />
                                    <span className="slider"></span>
                                    <label
                                        htmlFor="check_vagas3"
                                        className="form-check-label margin-check"
                                    >
                                        3
                                    </label>
                                </div>
                                <div className="form-check checkbox-inline">
                                    <input
                                        className="form-check-input"
                                        name="check_vagas4"
                                        id="check_vagas4"
                                        checked={this.props.vagas.includes(4)}
                                        onChange={this.props.handleVagasChanged}
                                        type="checkbox"
                                        value="4"
                                    />
                                    <span className="slider"></span>
                                    <label
                                        htmlFor="check_vagas4"
                                        className="form-check-label margin-check"
                                    >
                                        4+
                                    </label>
                                </div>
                            </div>
                        )}
                        <div className="form-group row">
                            <div className="col-12">
                                <label htmlFor="ano_lancamento">
                                    Ano de lançamento
                                </label>

                                <MultiSelect
                                    resetFilterOnHide
                                    value={this.props.ano_lancamento}
                                    onChange={this.props.handleAnoLancamentoChanged}
                                    options={this.state.anos_lancamento_options}
                                    filter
                                    style={{width: "100%", borderRadius: '0px'}}

                                    placeholder="Selecione"
                                    display={"chip"}
                                    showClear={true}
                                    maxSelectedLabels={3}
                                    selectedItemsLabel={"{0} items selecionados"}
                                    emptyFilterMessage={"Nenhum resultado encontrado"}

                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <div className="col-12">
                                <label htmlFor="ano_lancamento">
                                    Mês e ano de lançamento
                                </label>

                                <DatePicker
                                    locale="pt-BR"
                                    name="ano_lancamento"
                                    className="form-control"
                                    style={{width: "155%"}}
                                    dateFormat="MM/yyyy"
                                    showMonthYearPicker
                                    isClearable={this.props.mes_ano_lancamento != '' ? true : false}
                                    autoComplete="off"
                                    selected={this.props.mes_ano_lancamento}
                                    onChange={
                                        this.props.handleMesAnoLancamentoChanged
                                    }
                                    components={reactSelectIcons}

                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <div className="col-12">
                                <label htmlFor="estagio">
                                    Estágio da obra
                                </label>

                                <MultiSelect
                                    resetFilterOnHide
                                    value={this.props.estagio}
                                    onChange={
                                        this.props.handleEstagioChanged
                                    }
                                    options={estagios}
                                    style={{width: "100%", borderRadius: '0px'}}

                                    filter
                                    placeholder="Selecione"
                                    display={"chip"}
                                    showClear={true}
                                    maxSelectedLabels={3}
                                    selectedItemsLabel={"{0} items selecionados"}
                                    emptyFilterMessage={"Nenhum resultado encontrado"}


                                />
                            </div>
                        </div>

                        {/* {window.authenticatedUserCanQueryPolos === true && (
                            <div className="form-check checkbox-inline">
                                <input
                                    className="form-check-input"
                                    name="check_poles"
                                    id="check_poles"
                                    checked={this.props.showPolosGeradores}
                                    onChange={(e) => {
                                        let checked = e.target.checked;
                                        this.props.setShowPolosGeradores(checked);
                                    }}
                                    type="checkbox"
                                    value="true"
                                />
                                <span className="slider"></span>
                                <label
                                    htmlFor="check_poles"
                                    className="form-check-label margin-check"
                                >
                                    Mostrar polos geradores
                                </label>
                            </div>
                        )} */}
                        {this.props.showPolosGeradores && (
                            <>
                                <div className="form-group row">
                                    <div className="col-12">
                                        <label htmlFor="estagio">
                                            Polos Geradores
                                        </label>
                                        <MultiSelect
                                            resetFilterOnHide
                                            value={this.props.polos_geradores_types_selected}
                                            onChange={this.props.setPolosGeradoresTypes}
                                            name="tipos"
                                            options={this.state.types}
                                            style={{width: "100%", borderRadius: '0px'}}

                                            filter
                                            placeholder="Selecione"
                                            display={"chip"}
                                            showClear={true}
                                            maxSelectedLabels={3}
                                            selectedItemsLabel={"{0} items selecionados"}
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                        {this.props.tipo_empreendimento.includes(
                            "Horizontal"
                        ) && (
                            <>
                                <div className="form-group row">
                                    <div className="col-md-6 col-sm-6 col-lg-6">
                                        <label>Taxas de juros mínima</label>
                                        <input
                                            type="number"
                                            name="juros_min"
                                            value={this.props.juros_minimo}
                                            onChange={
                                                this.props
                                                    .handleJurosMinimoChanged
                                            }
                                            style={{padding: "3px"}}
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-lg-6">
                                        <label>Taxa de juros máxima</label>
                                        <input
                                            type="number"
                                            name="juros_max"
                                            value={this.props.juros_maximo}
                                            onChange={
                                                this.props
                                                    .handleJurosMaximoChanged
                                            }
                                            style={{padding: "3px"}}
                                            className="form-control"
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md-6 col-sm-6 col-lg-6">
                                        <label>Número de parcelas mínimo</label>
                                        <input
                                            type="number"
                                            name="parcelas_min"
                                            value={this.props.parcelas_minimo}
                                            onChange={
                                                this.props
                                                    .handleParcelasMinimoChanged
                                            }
                                            style={{padding: "3px"}}
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-lg-6">
                                        <label>Número de parcelas máximo</label>
                                        <input
                                            type="number"
                                            name="parcelas_max"
                                            value={this.props.parcelas_maximo}
                                            onChange={
                                                this.props
                                                    .handleParcelasMaximoChanged
                                            }
                                            style={{padding: "3px"}}
                                            className="form-control"
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md-6 col-sm-6 col-lg-6">
                                        <label>Valor parcela mínima</label>
                                        <IntlCurrencyInput
                                            currency="BRL"
                                            config={currencyConfig}
                                            onChange={
                                                this
                                                    .handleValorParcelaMinimaChange
                                            }
                                            style={{padding: "3px"}}
                                            value={
                                                this.props.valor_parcela_minima
                                            }
                                            className="valor form-control"
                                        />
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-lg-6">
                                        <label>Valor parcela máxima</label>
                                        <IntlCurrencyInput
                                            currency="BRL"
                                            config={currencyConfig}
                                            onChange={
                                                this
                                                    .handleValorParcelaMaximaChange
                                            }
                                            value={
                                                this.props.valor_parcela_maxima
                                            }
                                            style={{padding: "3px"}}
                                            className="valor form-control"
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                    <div className="card-footer btn-filtro-mobile"
                         style={{
                             position: "sticky",
                             bottom: 0,
                             backgroundColor: "#FFF",
                             padding: "5px 10px",
                             boxShadow: "0, 0, 3px, rgba(0,0,0, .2",
                         }}
                    >
                        <div className="row" id="container-btn-filtros">
                            <div className="col-6">
                                <button
                                    className="btn btn-block background-brain"
                                    onClick={this.props.handleSubmit}
                                >
                                    {this.props.overlays.length > 0
                                        ? 'ATUALIZAR'
                                        : 'BUSCAR'}
                                </button>
                            </div>
                            <div className="col-6">
                                <button
                                    className="btn btn-block btn-default default-gray"
                                    onClick={this.props.cleanState}
                                >
                                    LIMPAR
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FormFilters;
